import React, {useState,useEffect } from "react";
import { isUserExists, login_user } from "../../features/userSlice";
import { useDispatch, useSelector } from 'react-redux';
import {useNavigate } from "react-router-dom";
import { msgAccessPromt } from "../../constant/constant";
import { faEye, faEyeSlash, faMobileScreen, faRightToBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NavImage from "../../resources/NavImage";
import LanguageSwitcher from "../../resources/LanguageSwitcher";
import { useT } from "../../i18n";

const Login = () => {
    const [phone, setPhone] = useState(localStorage.getItem("phone_number") || "");
    const [mpin, setMpin] = useState("");
    const [showMpin, setShowMpin] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useT();
    const { isUserLogedIn } = useSelector((state) => state.users);

    const generateToken = () => {
        return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!/^\d{10}$/.test(phone)) {
            msgAccessPromt({ dispatch, error: true, msg: 'Enter Valid mobile number !!' });
            return;
        }
        if (!/^\d{4}$/.test(mpin)) {
            msgAccessPromt({ dispatch, error: true, msg: 'Enter your 4-digit MPIN !!' });
            return;
        }

        msgAccessPromt({ dispatch, msg: 'LOADING', error: true });
        const token = generateToken();
        const dataSet = new FormData();
        dataSet.append('phone_number', phone);
        dataSet.append('token_id', token);
        localStorage.setItem("phone_number", phone);
        localStorage.setItem("user_token", token);

        try {
            const data = await dispatch(isUserExists(dataSet)).unwrap();
            if (data.success) {
                const loginData = new FormData();
                loginData.append('phone_number', phone);
                loginData.append('password', mpin);
                loginData.append('token_id', token);
                await dispatch(login_user(loginData)).unwrap();
            } else {
                // Not registered yet: carry the number over to sign-up
                msgAccessPromt({ dispatch, error: false, msg: 'This number is not registered. Please create your account.' });
                navigate("/sign-up");
            }
        } catch (error) {
            console.error('API Error:', error);
            msgAccessPromt({ dispatch, error: true, msg: error || 'Unable to sign in. Please try again.' });
        }
    };

    const handlePhoneChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 10) {
            setPhone(value);
        }
    };

    const handleMpinChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 4) {
            setMpin(value);
        }
    };

    const goToSignup = (e) => {
        e.preventDefault();
        if (/^\d{10}$/.test(phone)) {
            localStorage.setItem("phone_number", phone);
            if (!localStorage.getItem("user_token")) {
                localStorage.setItem("user_token", generateToken());
            }
        }
        navigate("/sign-up");
    };

    useEffect(() => {
        if (isUserLogedIn) {
            navigate("/home");
        }
    }, [isUserLogedIn, navigate]);


    return (
        <div className="bodyDiv login-screen">
            <LanguageSwitcher className="auth-lang" />
            <div className="auth-logo">
                <NavImage />
                <p className="brand-tagline">{t("Every Win, Securely Paid.")}</p>
            </div>
            <form className="login-card" onSubmit={handleSubmit}>
                <div className="login-heading">
                    <div>
                        <h1>{t('Enter Number')}</h1>
                        <p>{t('Enter your valid mobile number')}</p>
                    </div>
                    <div className="login-icon-badge" aria-hidden="true">
                        <FontAwesomeIcon icon={faMobileScreen} />
                    </div>
                </div>

                <div className="login-fields">
                    <label className="login-field">
                        <span className="visually-hidden">{t("Mobile number")}</span>
                        <input
                            type="tel"
                            inputMode="numeric"
                            autoComplete="tel"
                            value={phone}
                            onChange={handlePhoneChange}
                            placeholder={t("Enter mobile number")}
                            aria-label={t("Enter mobile number")}
                        />
                        <FontAwesomeIcon className="login-field-icon" icon={faMobileScreen} aria-hidden="true" />
                    </label>
                    <label className="login-field">
                        <span className="visually-hidden">{t("4-digit MPIN")}</span>
                        <input
                            type={showMpin ? "text" : "password"}
                            inputMode="numeric"
                            autoComplete="current-password"
                            value={mpin}
                            onChange={handleMpinChange}
                            placeholder={t("Enter your 4-digit MPIN")}
                            aria-label={t("Enter your 4-digit MPIN")}
                            maxLength={4}
                        />
                        <button
                            className="login-input-icon"
                            type="button"
                            onClick={() => setShowMpin((visible) => !visible)}
                            aria-label={showMpin ? t("Hide MPIN") : t("Show MPIN")}
                        >
                            <FontAwesomeIcon icon={showMpin ? faEyeSlash : faEye} />
                        </button>
                    </label>
                </div>

                <button type="submit" className="continue-button">
                    <FontAwesomeIcon icon={faRightToBracket} aria-hidden="true" />
                    <span>{t('Continue')}</span>
                </button>

                <div className="login-footer">
                    <p>{t("New here?")} <a href="/sign-up" onClick={goToSignup}>{t("Sign up")}</a></p>
                </div>
            </form>
        </div>
    );
};

export default Login;